import { ButtonHTMLAttributes } from "react";

import { LoadingSpinner } from "@enkor/design/components";
import { grayScale } from "@enkor/design/colors";

import * as S from "./SubmitButton.style";

interface SubmitButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isReadyToSubmit: boolean;
  isLoading: boolean;
}

const SubmitButton = ({
  isReadyToSubmit,
  isLoading,
  ...rest
}: SubmitButtonProps) => {
  return (
    <S.Button
      type="submit"
      $isReadyToSubmit={isReadyToSubmit}
      disabled={isLoading}
      {...rest}
    >
      {isLoading ? (
        <LoadingSpinner loaderType="PulseLoader" color={grayScale.white} />
      ) : (
        "Continue with Email"
      )}
    </S.Button>
  );
};

export default SubmitButton;
